import { apiPaths } from 'api/kinerja/kepala-sekolah/config'
import { useQueryApi } from 'utils/api'

import type { CommonResponse } from 'types/api'
import type { UseQueryOptions } from 'react-query'

type TRequestPayloadCommonConfig = {
  key: 'PENETAPAN_TAHUNAN_TIME_RANGE'
}

export type TResponseCommonConfig = CommonResponse<{
  startDate?: {
    day: number
    month: number
  }
  endDate?: {
    day: number
    month: number
  }
}>

export const API_GET_COMMON_CONFIG = 'API_GET_COMMON_CONFIG'

export function useApiGetCommonConfig(
  params: TRequestPayloadCommonConfig,
  opts?: UseQueryOptions<TResponseCommonConfig>
) {
  return useQueryApi<TResponseCommonConfig>(
    `${apiPaths.commonConfig}/${params.key}`,
    {
      axiosConfig: {
        params: { skpYear: 1, skpPeriod: 1 }, // Both `skpYear` and `skpPeriod` are intentionally hardcoded to 1 as it's not used in the API for this case
      },
      queryConfig: { ...opts, useErrorBoundary: false },
      queryKey: [API_GET_COMMON_CONFIG],
    }
  )
}
